import { optionSchema } from '@/common/schemas/option.schema';
import { z } from 'zod';

const rolesSchema = z.object({
  value: z.string().optional(),
  type: z.string().optional()
})

const geosSchema = z.object({
  value: z.string().optional(),
  type: z.string().optional()
})

export const userSchema = z.object({
  full_name: z.string().min(1, 'Campo Nome é obrigatório'),
  email: z.string().min(1, 'Campo e-mail é obrigatório').email('Use um formato de e-mail válido'),
  status: z.object({
    label: z.string().optional(),
    value: z.string().optional(),
  }).optional(),
  cpf: z.string().optional(),
  date_of_birth: z.string()
    .min(1, 'Campo obrigatório')
    .refine((data) => {
      if(data.length < 10) return false
      const year = Number(data.split('/')[2]);
      const currentYear = (new Date()).getFullYear();
      const difference = currentYear - year;
      if(difference < 10 || difference > 200) return false
      return true
    }, {message: 'Use uma data válida'}),
  phone: z.object({
    number: z.string().optional().nullable(),
  }),
  sicof_user_identification: z.string().optional(),
  roles: z.array(rolesSchema).min(1, 'Campo Perfil é obrigatório').default([]),
  geos: z.array(geosSchema).optional(),
  authentication_method: optionSchema,
})

export type UserValidationSchema = z.infer<typeof userSchema>
